import { i18n } from "@/utils/i18n";

export default {
  namespaced: true,
  state: {
    endpoint: "/lamcom/enfocus_switch/layouts/",
    key: "layout",
    fetchKey: "layouts",
    permissionKey: ""
  },
  mutations: {},
  actions: {},
  getters: {}
};
